var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsWarningFilled = function SvgIconsWarningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h13.554v13.557H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.333 3.333)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.488 10.903A1.006 1.006 0 1 1 6.066 9.48a1.006 1.006 0 0 1 1.422 1.422zm-1.267-2.94h1.111V2.36h-1.11v5.603zm5.35-5.98a6.788 6.788 0 0 0-9.588 0 6.789 6.789 0 0 0 0 9.589 6.736 6.736 0 0 0 4.794 1.985 6.736 6.736 0 0 0 4.794-1.985 6.789 6.789 0 0 0 0-9.59z",
    fill: "#F57474",
    mask: "url(#b)"
  }))));
};
export { SvgIconsWarningFilled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iaTYxcGdoN2JoYSIgZD0iTTAgMGgxMy41NTR2MTMuNTU3SDB6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjMzMyAzLjMzMykiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPG1hc2sgaWQ9Imx0OXRjeHdpc2IiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNpNjFwZ2g3YmhhIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDxwYXRoIGQ9Ik03LjQ4OCAxMC45MDNBMS4wMDYgMS4wMDYgMCAxIDEgNi4wNjYgOS40OGExLjAwNiAxLjAwNiAwIDAgMSAxLjQyMiAxLjQyMnptLTEuMjY3LTIuOTRoMS4xMTFWMi4zNmgtMS4xMXY1LjYwM3ptNS4zNS01Ljk4YTYuNzg4IDYuNzg4IDAgMCAwLTkuNTg4IDAgNi43ODkgNi43ODkgMCAwIDAgMCA5LjU4OSA2LjczNiA2LjczNiAwIDAgMCA0Ljc5NCAxLjk4NSA2LjczNiA2LjczNiAwIDAgMCA0Ljc5NC0xLjk4NSA2Ljc4OSA2Ljc4OSAwIDAgMCAwLTkuNTl6IiBmaWxsPSIjRjU3NDc0IiBtYXNrPSJ1cmwoI2x0OXRjeHdpc2IpIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";